import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { LoadingContext } from 'context/loadingContext';
import { useContextHook } from 'use-context-hook';
import { Th, Td } from './TableCell.styles';

function TableCell({ heading, children, ...rest }) {
  const { isLoading } = useContextHook(LoadingContext, {
    isLoading: 1,
  });
  function CellType(props) {
    return heading ? <Th {...props} /> : <Td {...props} />;
  }

  return <CellType {...rest}>{isLoading ? <Skeleton width={100} height={15} /> : children}</CellType>;
}

export default TableCell;
